// extracted by mini-css-extract-plugin
module.exports = {"listOfItems":"_7SU23irZSHwcCxLNAIH_Y","item":"_3utVyMlh-cyEbWqzbMOCxF","dot":"_39Z9-5lcF5_prk-eY7aDiA"};